
export const gdGetTimestamp = function () {
    return Math.floor(Date.now() / 1000);
}